import React from 'react'
import Marquee from 'react-fast-marquee'

export default function Slider() {
  return (
    <div className=' '>
      <Marquee className='bg-[#FFF200] font-bold text-[#FF122F] py-3 xxl:py-10 border-t-4 border-b-4 border-black'>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map(
          (idx) => (
            <>
              <h3 className='ml-5'>
                BITCOIN PIZZA <span className='inline-block ml-5'>-</span>
              </h3>
            </>
          )
        )}
      </Marquee>
    </div>
  )
}
